import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { AppBar, IconButton, Toolbar, Grid } from "@material-ui/core";
import LightBulbIcon from "@material-ui/icons/EmojiObjects";
import { useAppContext } from "store/context";
import Logo from "components/Logo";
import AccountMenu from "components/AccountMenu";
import useStyles from "./styles";

const Header = ({ open }) => {
  const classes = useStyles();
  const { toggleTheme } = useAppContext();

  return (
    <AppBar
      color="default"
      position="fixed"
      elevation={2}
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
    >
      <Toolbar>
        <Grid container spacing={0} alignItems="center">
          <Grid item>
            <div className={classes.title}>
              <Logo width={38} />
              <span className={classes.titleInner}>
                Barista Station {process.env.REACT_APP_DEMO_MODE ? "(demo)" : null}
              </span>
            </div>
          </Grid>
          <Grid item xs />
          <Grid item>
            <IconButton color="inherit" className={classes.button} aria-label="toggle-theme" onClick={toggleTheme}>
              <LightBulbIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <AccountMenu />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  open: PropTypes.bool,
};

Header.defaultProps = {
  open: false,
};

export default Header;
